import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'

interface Props {
  open: boolean
  onClose: () => void
  imageUrl: string
  filename: string
}

export function ImagePreviewDialog({ open, onClose, imageUrl, filename }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
        {filename}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <Box
          component="img"
          src={imageUrl}
          alt={filename}
          sx={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
        />
      </DialogContent>
    </Dialog>
  )
}
